import React, {PureComponent} from 'react'
import injectSheet from 'react-jss'
import ImageOrVideo from "../Widgets/ImageOrVideo"
import Caption from "../Widgets/Caption"
import Quote from "../Widgets/Quote"
import theme from "../../styles/theme"
import ShopTheLookLink from "../ShopThLook/ShopTheLookLink"

const MAX_IMAGE_WIDTH = 1280;

class ImageWithQuote extends PureComponent {

    render() {
        const {classes, item} = this.props;
        const {image, video, link, quote, quote_attribution, caption, shop_the_look_title, shopItems, quote_location_vertical, quote_location_horizontal} = item;

        const hasShopItems = shopItems && shopItems.length > 0;
        const shopTheLookImage = hasShopItems && ((image && image.desktop) || (video && video.image.desktop))

        return (
            <section className={classes.container}>
                <ImageOrVideo images={image} video={video} link={!hasShopItems && link} sizes={`min-width: ${MAX_IMAGE_WIDTH}px ${MAX_IMAGE_WIDTH}px, 100vw`} className={classes.image}>
                    {hasShopItems ? <ShopTheLookLink title={shop_the_look_title} shopItems={shopItems} image={{desktop: shopTheLookImage}}
                                                     horizontalPosition={quote_location_horizontal} verticalPosition={quote_location_vertical} /> :
                        (quote && <Quote className={classes.quoteContainer} quote={quote} quote_attribution={quote_attribution} imageQuote={true}/>) }
                </ImageOrVideo>
                {caption && <Caption key="caption" caption={caption} className={classes.caption}></Caption>}
            </section>
        )
    }
}

const getFlexPosition = (location) => {
    switch( location ) {
        case "Left":
        case "Top":
            return "flex-start";
        case "Center":
            return "center";
        default:
            return "flex-end";
    }
}

export default injectSheet(
    {
        container: {
            display: "flex",
            flexDirection: "column-reverse",
            position: "relative",
            width: '100%',
            margin: 0,
            marginLeft: 'auto',
            marginRight: 'auto',
            padding: ({item: {image_size}}) => !image_size ? 0 : `0 ${theme.spacing.small}`,
            [theme.breakpoint("mobile")]: {
                flexDirection: "column",
            },
            [theme.breakpoint('tablet')]: {
                padding: [0 ,theme.spacing.small],
                maxWidth: '100%'
            },
            [theme.breakpoint('laptop')]: {
                maxWidth: ({item: {image_size}}) => image_size ? image_size : '100%'
            }
        },
        caption: {
            marginLeft: theme.spacing.tiny,
            marginRight: theme.spacing.tiny,
            [theme.breakpoint("mobile")]: {
                marginLeft: 0,
                marginRight: 0,
            },
        },
        quoteContainer: {
            pointerEvents: "none",
            position: "absolute",
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            display: "flex",
            alignItems: ({item:{quote_location_vertical}}) => getFlexPosition( quote_location_vertical ),
            justifyContent: ({item:{quote_location_horizontal}}) => getFlexPosition( quote_location_horizontal ),
        },
    }
)(ImageWithQuote)





// WEBPACK FOOTER //
// ./src/components/Article/ImageWithQuote.js